/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespRefineMenu_viewer = {|
  +isSbSharedRefineMenuDisplayPrefsSelectEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenu_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
